import { useState, useCallback } from 'react';

interface UseAsyncState<T> {
    data: T | null;
    loading: boolean;
    error: string | null;
}

export const useAsync = <T>() => {
    const [state, setState] = useState<UseAsyncState<T>>({
        data: null,
        loading: false,
        error: null,
    });

    const execute = useCallback(async (asyncFunction: () => Promise<T>) => {
        setState(prev => ({ ...prev, loading: true, error: null }));

        try {
            const result = await asyncFunction();
            setState({ data: result, loading: false, error: null });
            return result;
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'An error occurred';
            setState({ data: null, loading: false, error: errorMessage });
            throw error;
        }
    }, []);

    const retry = useCallback(() => {
        setState(prev => ({ ...prev, error: null }));
    }, []);

    return {
        ...state,
        execute,
        retry,
    };
}; 